import { Box, Button, Tooltip, Typography } from "@mui/material";
import { ViewColumn } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

type Props = {
  /** First button: calendar (e.g. FleetEventChildPartial with part="calendar") */
  calendarNode: React.ReactNode;
  showColumnTogglesPanel: boolean;
  onToggleColumnTogglesPanel: () => void;
  isEditable: boolean;
};

export function FleetToolbarTitleActions({
  calendarNode,
  showColumnTogglesPanel,
  onToggleColumnTogglesPanel,
  isEditable
}: Readonly<Props>) {
  const { t } = useTranslation();

  return (
    <Box
      data-testid="fleet-toolbar-title-actions"
      sx={{ display: "flex", alignItems: "center", gap: 1, ml: { xs: 0, md: 1 } }}
    >
      {calendarNode}

      {isEditable && (
        <Tooltip title={<Typography>{t("Show/hide optional columns")}</Typography>}>
          <Button
            sx={{ height: "40px", minWidth: 30 }}
            color={showColumnTogglesPanel ? "primary" : "secondary"}
            onClick={onToggleColumnTogglesPanel}
            data-testid="fleet-toggle-column-toggles-panel"
            aria-pressed={showColumnTogglesPanel}
          >
            <ViewColumn />
          </Button>
        </Tooltip>
      )}
    </Box>
  );
}
